import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { Router } from "@angular/router";
import { IAppDataItem } from "src/app/interfaces/app-data.interface";
import { ICourts } from "src/app/interfaces/sports-facility.interface";

@Component({
  selector: "app-card",
  templateUrl: "./card.component.html",
  styleUrls: ["./card.component.scss"],
})
export class CardComponent implements OnChanges {
  @Input() card: any = {};
  @Input() type: string = "";
  startingSlot: string;
  sportsCategories: IAppDataItem[];

  constructor(private router: Router) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.["card"]?.currentValue) {
      const courts = changes?.["card"]?.currentValue?.courts;
      this.parseSportsCategories(courts);

      const startingCourt = courts[0];
      if (startingCourt?.duration === "30") this.startingSlot = "Half Hour";
      else if (startingCourt?.duration === "45")
        this.startingSlot = "45 Minutes";
      else if (startingCourt?.duration === "60") this.startingSlot = "Hour";
      else if (startingCourt?.duration === "90")
        this.startingSlot = "Hour & Half";
      else if (startingCourt?.duration === "120")
        this.startingSlot = "Two Hours";
    }
  }

  parseSportsCategories = (courts: ICourts[]) => {
    let allSportsCategories: IAppDataItem[] = [];
    if (!courts?.length) return;
    courts?.forEach((it) => {
      it?.sportsCategories?.forEach((sp) => {
        if (!allSportsCategories?.find((asc) => asc.id === sp.id))
          allSportsCategories.push(sp);
      });
    });

    this.sportsCategories = allSportsCategories;
  };

  navigate = () => {
    if (this.type == "courts")
      this.router.navigate([`/facility-detail/${this.card.id}`]);
    if (this.type == "teams")
      this.router.navigate([`/team-detail/${this.card.id}`]);
  };

  onNavigateToFacilityDetail = () => {
    const updatedName = this.card.name?.replace(/[-_. ']/g, "");
    this.router.navigate([`/facility-detail/${updatedName}-${this.card.id}`]);
  };
}
